import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet-async";
import Footer from '../components/Footer';
import { styled } from 'styled-components'
import { SEARCH_OPTIONS } from '../constants/constants';
import Header from '../components/Header';

const SearchResults = styled.div`
    position: absolute;
    left: 50%;
    width: 70vw;
    transform: translateX(-50%);
    max-width: 700px;
    margin-top: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const Anasayfa = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [showResults, setShowResults] = useState(false);
    const searchResultsRef = useRef(null);

    const normalizeText = (text) =>
        text.toLowerCase()
            .normalize("NFD")
            .replace(/ç/g, 'c')
            .replace(/ğ/g, 'g')
            .replace(/ı/g, 'i')
            .replace(/ö/g, 'o')
            .replace(/ş/g, 's')
            .replace(/ü/g, 'u')
            .replace(/[\u0300-\u036f]/g, "");

    const filteredSearchOptions = SEARCH_OPTIONS.filter(option => normalizeText(option.text).includes(normalizeText(searchQuery))).slice(0, 4);

    if (searchQuery && filteredSearchOptions.length === 0) {
        filteredSearchOptions.push({ text: "Tüm Hesaplamalara Göz Atın", href: "hesaplamalar" });
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            const searchForm = document.querySelector('form');
            if (searchForm && !searchForm.contains(event.target) && searchResultsRef.current && !searchResultsRef.current.contains(event.target)) {
                setShowResults(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const hideResults = () => setTimeout(() => setShowResults(false), 150);

    return (
        <>
            <Helmet>
                <title>Legalbul</title>
                <link rel="canonical" href={`${window.location.origin}${window.location.pathname}`} />
                <meta name="description" content="Sitemizin ana sayfası." />
            </Helmet>
            
            <Header />
            <section className="container-fluid align-content-center text-center py-5 bg-custom-gray" style={{ minHeight: '500px', position: 'relative' }}>
                <h1 className="display-4 fw-bold">
                    Neyi <span className="text-orange">Hesaplamak</span> İstiyorsun?
                </h1>
                <p className="lead text-muted">Mevzuat ile uyumlu, devamlı güncel, hızlı ve dinamik</p>

                {/* Search Form */}
                <form className="d-flex justify-content-center my-2" onClick={() => setShowResults(true)}>
                    <div className="input-group flex-row" style={{ maxWidth: '700px' }}>
                        <span className="input-group-text bg-white">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                            </svg>
                        </span>
                        <input
                            type="text"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className="form-control border-start-0 searchbar"
                            placeholder="Hesaplama konusu"
                            onFocus={() => setShowResults(true)}
                            onBlur={hideResults}
                        />
                    </div>
                </form>

                {/* Search Results */}
                {showResults && filteredSearchOptions.length > 0 && searchQuery && (
                    <SearchResults ref={searchResultsRef}>
                        <ul className="list-group floating-results">
                            {filteredSearchOptions.map(option => (
                                <li key={option.href} className="list-group-item">
                                    <Link to={option.href} className="text-decoration-none text-black">
                                        {option.text}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </SearchResults>
                )}

                {/* Popular Searches */}
                <div className="d-flex justify-content-center align-items-center mt-3">
                    <span className="text-muted me-2">Popüler Aramalar</span>
                    <Link to="/hesaplamalar/kidem-tazminati-hesaplama" className="text-decoration-underline border-0 btn me-2">Kıdem Tazminatı</Link>
                    <Link to="/hesaplamalar/vekalet-ucreti-hesaplama" className="text-decoration-underline border-0 btn me-2">Vekalet Ücreti</Link>
                    <Link to="/hesaplamalar/icra-masrafi-hesaplama" className="text-decoration-underline border-0 btn">İcra Masrafı</Link>
                </div>
            </section>

            <Footer showSSS={true}/>
        </>
    );
};

export default React.memo(Anasayfa);
